import {useEffect, useRef, useState} from "react";
import { t } from "i18next";
import { AutoComplete, Select, Spin } from 'antd';
import ApiService from "../../core/service/ApiService";
import DebounceSelect from "../../core/components/DebounceSelect";

export default function PatientSelect({ onSelect }) {
    const [search, setSearch] = useState('')
    const [spin, setSpin] = useState(false)
    const [lastAppointments, setLastAppointments] = useState([]);
    const searchResult = useRef([])

    const load = async () => {
        const res = await ApiService.Appointment.GetLastAppointmentPatients();
        if (res.success) {
            setLastAppointments(res.data)
        }
    }

    useEffect(() => {
        load()
    }, [])

    const searchPatient = async (value) => {
        setSpin(true)
        if (!value)
            return []

        const res = await ApiService.Patient.SearchPatient(value);

        setSpin(false)
        if (res.success) {
            searchResult.current = res.data
            return res.data.map(x => {
                return {
                    label: (
                        <div>
                            <b>{x.name} {x.lastname}</b>
                            {` - `}ID: {x.customId}
                        </div>
                    ),
                    value: x.id
                }
            })
        }
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', margin: 0, padding: 0, flex: 1 }}>
            <DebounceSelect
                placeholder={t('Search Patient')}
                style={{ width: '100%' }}
                debounceTimeout={250}
                labelInValue={true}
                mode={'single'}
                showSearch={true}
                onSelect={(e) => {
                    const pat = [...lastAppointments, ...searchResult.current].find(x => x.id === e.value)
                    onSelect && onSelect(e.value, pat) && setSearch('')
                }}
                value={search ? search : undefined}
                onChange={(e) => setSearch(e)}
                fetchOptions={async (val) => searchPatient(val)}
            >
                <Select.OptGroup value={'X'} label={t('Last Appointments')}>
                    {
                        lastAppointments.map(x => (
                            <Select.Option key={x.id} value={x.id}>
                                <div>
                                    <b>{x.name} {x.lastname}</b>
                                    {x.customId && ` - ID: ${x.customId}`}
                                </div>
                            </Select.Option>
                        ))
                    }
                </Select.OptGroup>
            </DebounceSelect>
            {/*<Spin size={'small'} style={{marginLeft: 8}} spinning={spin}/>*/}
        </div>
    )
}